{
  "name": "rulens",
  "version": "0.2.2",
  "description": "CLI to extract and format linting rules into Markdown for documentation and AI agents",
  "keywords": [
    "biome",
    "documentation",
    "eslint",
    "linting",
    "markdown"
  ],
  "repository": {
    "type": "git",
    "url": "https://github.com/MH4GF/rulens"
  },
  "license": "MIT",
  "author": "MH4GF",
  "files": [
    "dist"
  ],
  "engines": {
    "node": ">=20.0.0"
  },
  "type": "module",
  "publishConfig": {
    "access": "public"
  },
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "bin": {
    "rulens": "./dist/index.js"
  },
  "dependencies": {
    "bundle-require": "5.1.0",
    "commander": "13.1.0",
    "execa": "9.5.2",
    "neverthrow": "8.2.0",
    "picocolors": "1.1.1",
    "valibot": "1.0.0"
  },
  "devDependencies": {
    "@biomejs/biome": "1.9.4",
    "@changesets/cli": "2.29.2",
    "@mh4gf/configs": "0.4.6",
    "@mh4gf/eslint-config": "0.6.11",
    "@tsconfig/strictest": "2.0.5",
    "@types/node": "22.15.3",
    "@vitest/coverage-v8": "3.1.2",
    "@vitest/ui": "3.1.2",
    "cheerio": "1.0.0",
    "eslint": "9.26.0",
    "knip": "5.53.0",
    "syncpack": "13.0.4",
    "tsup": "8.4.0",
    "tsx": "4.19.4",
    "typescript": "5.8.3",
    "vitest": "3.1.2"
  },
  "scripts": {
    "build": "tsup",
    "changeset": "changeset",
    "crawl": "tsx scripts/crawl-biome-rules.ts",
    "dev": "tsup --watch",
    "fmt": "pnpm run fmt:syncpack-fix && pnpm run fmt:syncpack-format && pnpm run fmt:biome && pnpm run fmt:knip",
    "fmt:biome": "biome check --write --unsafe . --log-level=warn",
    "fmt:knip": "knip --fix",
    "fmt:rulens": "node dist/index.js generate",
    "fmt:syncpack-fix": "syncpack fix-mismatches",
    "fmt:syncpack-format": "syncpack format",
    "lint": "pnpm run lint:biome && pnpm run lint:tsc && pnpm run lint:syncpack && pnpm run lint:eslint && pnpm run lint:knip && pnpm run lint:rulens",
    "lint:biome": "biome check . --log-level=warn",
    "lint:eslint": "eslint .",
    "lint:knip": "knip",
    "lint:rulens": "pnpm build && node dist/index.js lint",
    "lint:syncpack": "syncpack lint",
    "lint:tsc": "tsc --noEmit",
    "release": "pnpm build && changeset publish",
    "test": "vitest run",
    "test:coverage": "vitest run --coverage",
    "test:coverage:badge": "pnpm test:coverage && tsx scripts/generate-coverage-badge.ts",
    "test:watch": "vitest",
    "version": "changeset version"
  },
  "packageManager": "pnpm@10.10.0+sha512.d615db246fe70f25dcfea6d8d73dee782ce23e2245e3c4f6f888249fb568149318637dca73c2c5c8ef2a4ca0d5657fb9567188bfab47f566d1ee6ce987815c39"
}
